import { Stack, Flex, Copy } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IReceiptLineProps {
  name: string;
  value: string;
  newValue?: string;
  explanation?: React.ComponentType;
}

export function ReceiptLine({
  name,
  value,
  newValue,
  explanation,
}: IReceiptLineProps): JSX.Element {
  const Explanation = explanation;
  return (
    <Stack y="sm">
      <Flex justifyContent="space-between">
        <Flex>
          <Copy variant="lead" strong color="secondaryText">
            {name}
          </Copy>
          {explanation && <Explanation />}
        </Flex>
        <Flex justifyContent="flex-end">
          <Stack as="span" x="xxx-sm">
            <Copy
              variant="lead"
              style={{ textDecoration: newValue ? 'line-through' : 'none' }}
            >
              {value}
            </Copy>
          </Stack>
          {newValue && (
            <Copy variant="lead" strong color="success">
              {newValue}
            </Copy>
          )}
        </Flex>
      </Flex>
    </Stack>
  );
}
